<template>
    <div
        :class="{
            'min-vh-100':
                $route.path === '/login' || $route.path === '/registration',
        }"
    >
        <GlobalLoader />
        <div
            class="main-app"
            id="page"
            v-if="
                $route.path !== '/login' &&
                $route.path !== '/calendar' &&
                $route.path !== '/registration' &&
                $route.name !== 'WidgetPublicView' &&
                $route.name !== 'WidgetPublicViewPayment' &&
                $route.name !== 'CampaignPublicViewPayment'
            "
        >
            <div class="sidebar-new" :class="sidebarOverrideBg">
                <NewSideBar></NewSideBar>
            </div>
            <div class="main-content">
                <NewHeader />
                <div class="side-content" id="content">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <div v-else class="min-vh-100 overflow-hidden">
            <GlobalLoader />
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import NewHeader from './commons/Header/NewHeader.vue';
import NewSideBar from './commons/Sidebar/NewSideBar.vue';
import GlobalLoader from './commons/GlobalLoader/GlobalLoader';
import DibbleJS from './dibble';
import { EventBus } from '@/utils/event-bus';

export default {
    name: 'App',
    components: {
        GlobalLoader,
        NewHeader,
        NewSideBar,
    },
    data() {
        return {
            sidebarOverrideBg: '',
        };
    },
    mounted() {
        if (
            this.$route.path !== '/login' &&
            this.$route.path !== '/registration' &&
            this.$route.path !== '/calendar' &&
            this.$route.name !== 'WidgetPublicView' &&
            this.$route.name !== 'WidgetPublicViewPayment' &&
            this.$route.name !== 'CampaignPublicViewPayment'
        ) {
            DibbleJS.checkIsExpiredSession();
        }

        EventBus.$on('sidebarBgClass', (value) => {
            console.log('sidebarClass', value);
            this.sidebarOverrideBg = value;
        });
    },
};
</script>

<style scoped lang="scss">
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import 'assets/css/bootstrap-select.min.css';
@import 'assets/css/all.css';
@import 'assets/css/main.css';
@import 'assets/css/responsive.css';
@import 'assets/css/custom.css';
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

/* #page {
        direction: rtl;
    }*/
.main-app {
    display: flex;
    width: 100%;
}

.sidebar-new {
    width: 250.24px;
    height: 100vh;
    background: #e8eff1;
    border-radius: 0px 0px 50px 0px;

    &.Unverified {
        background: #ffc3c3;
    }
    &.Pending {
        background: #ffebc2;
    }
    &.Rejected {
        background: #171a1c;
        color: #ffffff;
    }
}

.main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: auto;
    background: linear-gradient(180deg, #f0f1f2 36.98%, #f0f5f6 100%);

    .side-content {
        flex: 1;
        overflow: auto;
    }
}
</style>

<style lang="scss">
@import 'assets/scss/main.scss';
</style>
